
if (!customElements.get('media-grid-slide')) {
  // Wait for Splide to be available
  const waitForSplide = () => {
    return new Promise((resolve) => {
      if (typeof Splide !== 'undefined') {
        resolve();
      } else {
        const checkSplide = setInterval(() => {
          if (typeof Splide !== 'undefined') {
            clearInterval(checkSplide);
            resolve();
          }
        }, 100); // Check every 100ms
      }
    });
  };

  // Define SplideSlide with proper properties handling
  const SplideSlide = (element, properties) => {
    if (typeof Splide === 'undefined') {
      throw new Error('Splide is not loaded yet.');
    }
    const splideInstance = new Splide(element, properties); // Pass properties directly
    return splideInstance.mount();
  };

  class MediaGridSlides extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('section');
      this.mainSlides = this.querySelectorAll('[data-main-slide]');
      this.sliderInstances = [];
      this.prevButton = this.querySelector('[data-prev-slide]');
      this.nextButton = this.querySelector('[data-next-slide]');

      this.#init();
      this.#setupEventListeners();
    }

    async #init() {
      await waitForSplide(); // Ensure Splide is ready
      try {
        this.mainSlides.forEach((slide) => {
          const options = JSON.parse(slide.dataset.splide);
          this.sliderInstances.push(SplideSlide(slide, options));
        });
      } catch (error) {
        console.error('Failed to initialize Splide sliders:', error);
      }
    }

    #setupEventListeners() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.#navigate('prev', 'moving-reverse'));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.#navigate('next', 'moving-forward'));
      }

      this.#hoverHandler();
      this.#spotlightHandler();

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => console.log(e));
        this.addEventListener('shopify:block:deselect', (e) => console.log(e));
      }
    }

    /*#navigate(direction, className) {
      this.#changeScheme(direction);
      this.mainSlides.forEach((slide) => {
        slide.classList.remove(direction === 'next' ? 'moving-reverse' : 'moving-forward');
        slide.classList.add(className);
      });
      this.sliderInstances.forEach((slider) => slider.go(direction === 'next' ? '>' : '<'));
    }*/


    #navigate(direction, className) {
      this.#changeScheme(direction);

      this.mainSlides.forEach((slide) => {
        slide.classList.remove('moving-forward', 'moving-reverse');
        slide.classList.add(className);
      });

      this.sliderInstances.forEach((slider) => {
        // Move the slide instantly
        slider.go(direction === 'next' ? '>' : '<');

        // Clean previous custom-active classes
        slider.Components.Elements.slides.forEach(slide => {
          slide.classList.remove('slide-active');
        });

        // Get current index instantly after move
        const index = slider.index;

        // Use Splide's API to get rendered slide (clone or not)
        const currentSlide = slider.Components.Slides.getAt(index)?.slide;
        if (currentSlide) {
          currentSlide.classList.add('slide-active');
        }
      });
    }



    #changeScheme(direction) {
      const schemeElement = this.section.querySelector('[data-slide-scheme]');
      if (!schemeElement) return;

      const schemes = JSON.parse(schemeElement.dataset.slideScheme);
      const currentScheme = this.#getCurrentScheme(schemeElement);
      let currentIndex = schemes.indexOf(currentScheme);

      currentIndex =
        direction === 'next'
          ? (currentIndex + 1) % schemes.length
          : (currentIndex - 1 + schemes.length) % schemes.length;

      this.#updateSchemeClass(schemeElement, schemes[currentIndex]);
    }

    #getCurrentScheme(element) {
      return Array.from(element.classList).find((cls) => cls.startsWith('scheme-')) || null;
    }

    #updateSchemeClass(element, newScheme) {
      const currentScheme = this.#getCurrentScheme(element);
      if (currentScheme) element.classList.remove(currentScheme);
      element.classList.add(newScheme);
    }

    #hoverHandler() {
      if (!this.prevButton || !this.nextButton) return;

      document.addEventListener('mousemove', (e) => {
        const mouseX = e.clientX;
        const windowWidth = window.innerWidth;
        const threshold = windowWidth * 0.2;

        this.prevButton.classList.toggle('show', mouseX < threshold);
        this.nextButton.classList.toggle('show', mouseX > windowWidth - threshold);
      });
    }

    #spotlightHandler() {
      const spotlight = this.section.querySelector('[data-spotlight]');
      if (!spotlight) return;

      const smoothness = 0.3;
      let spotlightX = 0;
      let spotlightY = 0;

      this.section.addEventListener('mousemove', (e) => {
        const rect = this.section.getBoundingClientRect();
        const mouseX = e.clientX - rect.left - spotlight.offsetWidth / 2;
        const mouseY = e.clientY - rect.top - spotlight.offsetHeight / 2;

        spotlightX += (mouseX - spotlightX) * smoothness;
        spotlightY += (mouseY - spotlightY) * smoothness;

        spotlight.style.transform = `translate3d(${spotlightX}px, ${spotlightY}px, 0)`;
      });

      this.section.addEventListener('mouseout', () => {
        spotlight.style.transform = 'translate3d(0, 0, 0)';
      });
    }
  }

  customElements.define('media-grid-slide', MediaGridSlides);
}